// extracted by mini-css-extract-plugin
export var alternate = "_v-j";
export var black = "_v-6";
export var blue = "_v-f";
export var blueLight = "_v-e";
export var brand = "_v-8";
export var darkMode = "_v-b";
export var error = "_v-a";
export var gray = "_v-5";
export var grayBlue = "_v-d";
export var iconWrapper = "_v-3";
export var inactive = "_v-7";
export var indigo = "_v-g";
export var orange = "_v-i";
export var pink = "_v-h";
export var primary = "_v-0";
export var purple = "_v-9";
export var success = "_v-4";
export var warning = "_v-c";
export var white = "_v-1";
export var whiteSuccess = "_v-2";